export default ".slider {\n  width: 1024px;\n}\n\n.number-line {\n  width: 1024px;\n  margin: 0 auto;\n  display: block;\n}";